import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "vdmar_panel" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("legend", null, "ГЕНЕРАТОР ПАРОЛЕЙ", -1)
const _hoisted_3 = { class: "generate_button_div" }
const _hoisted_4 = {
  key: 0,
  class: "vdmar-table"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("fieldset", {
      class: "vdmar_fieldset",
      style: _normalizeStyle(_ctx.styleObject)
    }, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _createTextVNode(" Длина пароля "),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.passwordParams.passwordLenght) = $event)),
          maxlength: "2",
          size: "2",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkPasswordLenght()))
        }, null, 544), [
          [_vModelText, _ctx.passwordParams.passwordLenght]
        ]),
        _createTextVNode(" символов ")
      ]),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passwordParams.capitalLettersCheck) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.passwordParams.capitalLettersCheck]
        ]),
        _createTextVNode(" Прописные буквы ")
      ]),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.passwordParams.numbersCheck) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.passwordParams.numbersCheck]
        ]),
        _createTextVNode(" Цифры ")
      ]),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.passwordParams.specialCharactersCheck) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.passwordParams.specialCharactersCheck]
        ]),
        _createTextVNode("Специальные символы: "),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.passwordParams.specialCharacters) = $event)),
          maxlength: "3",
          size: "20"
        }, null, 512), [
          [_vModelText, _ctx.passwordParams.specialCharacters]
        ])
      ]),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.passwordParams.excludeCharactersCheck) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.passwordParams.excludeCharactersCheck]
        ]),
        _createTextVNode("Исключить символы: "),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.passwordParams.excludeCharacters) = $event)),
          maxlength: "25",
          size: "25"
        }, null, 512), [
          [_vModelText, _ctx.passwordParams.excludeCharacters]
        ])
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(" Количество паролей:"),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.passwordParams.passwordsCount) = $event)),
          maxlength: "2",
          size: "2",
          onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.checkPasswordCount()))
        }, null, 544), [
          [_vModelText, _ctx.passwordParams.passwordsCount]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          type: "button",
          class: "generate_button",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.generatePassword())),
          value: "Создать пароли"
        })
      ]),
      (_ctx.passwords.length > 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passwords, (password, item) => {
              return (_openBlock(), _createElementBlock("tr", { key: item }, [
                _createElementVNode("td", null, _toDisplayString(password), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}